import React, { useContext, useState, useEffect } from 'react'
// import { Link } from "react-router-dom"
import styles from './Nav.module.scss'
import {
	Row,
	Col,
	Dropdown,
	Image
} from 'react-bootstrap'
import { StateContext } from '../../StateContext'
import AuthenticationService from '../../services/authenticationService'
import { Link, useNavigate } from 'react-router-dom'

const Nav = () => {
	const { filterData } = useContext(StateContext)
	const { lmu, se, overviewHeader, lmuHeader, seHeader } = filterData
	const getHeader = () => {
		if (lmu) { return lmuHeader }
		if (se) { return seHeader }
		else return overviewHeader //overview
	}
	const [name, setName] = useState('')

	const navigate = useNavigate()

	const logout = () => {
		AuthenticationService.logout()
		navigate('/login')
	}
	useEffect(() => {
		const user = JSON.parse(localStorage.getItem('E2ICurrentUser') as string)
		user ? setName(user.name) : setName('Admin')
	}, [])

	return (
		<Row className={styles.navWrapper}>
			<Col>
				<div className={styles.logo}>
					<Link to='/'><Image className="d-block" src="/img/e2i_logo.png" /></Link>
				</div>
				{/* <h4>{getHeader()}</h4> */}
			</Col>
			<Col>
				<Row className="justify-content-right">
					<Col>
						<div className={styles.profileWrapper}>
							<Dropdown>
								<Dropdown.Toggle id="dropdown-basic" className={styles.dropDown}>
									<span>
										<span className="d-none d-md-block">Hi, {name} &nbsp;</span>
									</span>
								</Dropdown.Toggle>

								<Dropdown.Menu>
									<Dropdown.Item onClick={() => navigate('profile-settings')}>Settings</Dropdown.Item>
									<Dropdown.Item onClick={() => logout()}>Logout</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</Col>
				</Row>
			</Col>
		</Row>
	)
}

export default Nav